var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"account-page"},[_c('div',{staticClass:"account-page__inner"},[(_vm.contentReady)?_c('router-view'):_c('section',{staticClass:"py-8 px-8 white"},[_c('v-skeleton-loader',{staticClass:"profile-skeleton",attrs:{"type":"list-item-avatar, list-item-three-line, card-heading, image, actions"}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }